import { FunctionComponent, h } from 'preact'
import { MutableRef, useEffect, useMemo } from 'preact/hooks'

import { Branding, FieldScrollArea, FieldTitle, FormContainer, SafeArea, Svg } from 'components/ui'
import { useBrandingProps, usePostHeightChangeMessage } from 'scripts/hooks'
import { Field, FieldEntry } from 'scripts/type'
import useRefs from './useRefs'

import classes from './reply.module.scss'
import DescriptionField from 'components/business/ReplyForm/DescrpitionField'
import RadioButtonField from 'components/business/ReplyForm/RadioButtonField'
import TextareaField from 'components/business/ReplyForm/TextareaField'
import cls from 'classnames'

type Props = {
  field: Field
  descriptionField?: Field
  radioField?: Field
  textareaField?: Field
  onRadioValueChange: (fieldEntry: FieldEntry) => void
  onSubmit: (fieldEntry: FieldEntry) => void
  onClose?: () => void
}

const ReplyForm: FunctionComponent<Props> = (props) => {
  const { field, descriptionField, radioField, textareaField, onRadioValueChange, onSubmit, onClose } = props
  const { brandingUrl, brandingVisible } = useBrandingProps()
  const { contentRef, brandingRef, scrollAreaRef, safeAreaRef } = useRefs()
  const showTextareaField = useMemo(() => field.code === textareaField?.code, [field])

  const { postHeightChange } = usePostHeightChangeMessage(
    contentRef as MutableRef<HTMLDivElement>,
    brandingRef as MutableRef<HTMLDivElement>,
    20
  )

  useEffect(() => {
    setTimeout(() => {
      postHeightChange(safeAreaRef?.current?.getHeight() ?? 0)
    }, 0)
  }, [field])

  return (
    <FormContainer onClose={onClose} type="reply">
      <div className={cls(classes.content)}>
        <FieldScrollArea ref={scrollAreaRef}>
          <div ref={contentRef}>
            <div className={classes.header}>
              <Svg.Message />
              <FieldTitle title="您收到一条新的消息回复" />
            </div>
            {descriptionField && <DescriptionField field={descriptionField} />}
            {radioField && <RadioButtonField field={radioField} onRadioValueChange={onRadioValueChange} />}
            {textareaField && showTextareaField && (
              <TextareaField field={textareaField} onSubmit={onSubmit} visible={showTextareaField} />
            )}
          </div>
        </FieldScrollArea>
      </div>
      {brandingVisible && <Branding brandingUrl={brandingUrl!} ref={brandingRef} />}
      <SafeArea ref={safeAreaRef} />
    </FormContainer>
  )
}

export default ReplyForm
